import { atom } from "recoil";

/**
 * Flag to track if the wizard is open or not
 */
export const inProjectCreationWizardState = atom<boolean>({
  key: "inProjectCreationWizard",
  default: false,
});
